import React, { useEffect, useState } from 'react';
import { Grid, FormGroup, Typography, Switch, FormControlLabel, FormHelperText, IconButton, Modal, Box, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { useLang } from '~/hooks/useLang';
import { Controller, type UseFormGetValues, type UseFormSetValue } from 'react-hook-form';
import { Help } from '@mui/icons-material';

type CrudCheckBoxFieldProps = {
  readonly register: any;
  readonly model: any;
  readonly name: string;
  readonly getValues?: UseFormGetValues<any>;
  readonly checked: boolean;
  readonly control: any;
  readonly placeholder?: string;
  readonly setFormValue: UseFormSetValue<any>;
  readonly required?: boolean;
  readonly filterName?: string;
  readonly helperText?: string;
}

export default function CrudCheckBoxField(props: CrudCheckBoxFieldProps) {
  const { translate } = useLang()
  const { register, model, name, getValues, checked, control, placeholder, setFormValue, helperText } = props
  const [isCheck, setIsCheck] = useState(Boolean(checked) ? Boolean(checked) : false);
  const [openDialogHelper, setOpenDialogHelper] = useState(false)
  const handleOpen = () => setOpenDialogHelper(true);
  const handleClose = () => setOpenDialogHelper(false);

  useEffect(() => {
    setFormValue(name, isCheck)
  },[])

  return (
    <Grid item xs={4}>
      <>
        <Controller
          {...register(`${name}`)}
          name={name}
          control={control}
          defaultValue={isCheck}
          sx={{ mt: 0 }}
          render={(props) => (
            <FormGroup sx={{ paddingTop: '10px', display: 'flex', flexDirection: 'row' }}>
              <>
                <FormControlLabel
                  control={(
                    <Switch
                      {...props.field}
                      checked={props.field.value}
                      onChange={(event, value) => {
                        setIsCheck(Boolean(value));
                        setFormValue(name, value)
                        return props.field.onChange(Boolean(value));
                      }}
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                  )} label={translate(`${placeholder ? placeholder.charAt(0).toUpperCase() + placeholder.slice(1) : name.charAt(0).toUpperCase() + name.slice(1)}`)} />
                {helperText && helperText.length &&
                  <IconButton onClick={() => handleOpen()}>
                    <Help fontSize='small' />
                  </IconButton>
                }
              </>
            </FormGroup>
          )}
        />
        <Dialog
          open={openDialogHelper}
          onClose={handleClose}
        >
          <DialogTitle variant="h6" component="h2">
            {translate(`${placeholder ? placeholder.charAt(0).toUpperCase() + placeholder.slice(1) : name.charAt(0).toUpperCase() + name.slice(1)}`)}
          </DialogTitle>
          <DialogContent>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              {helperText}
            </Typography>
          </DialogContent>
        </Dialog>
      </>
    </Grid>


  )
}